import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccountAllocations from './account-allocation.reducer';

export const selectAccountAllocationsState = createFeatureSelector<
    fromAccountAllocations.State
>(fromAccountAllocations.accountAllocationsFeatureKey);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromAccountAllocations.adapter.getSelectors(selectAccountAllocationsState);

export const selectExpenseTypes = createSelector(
    selectAccountAllocationsState,
    x => x.expenseTypes
);
